module.exports = __webpack_public_path__ + "static/media/cn.f99eb7ba.svg";